import { Component, OnInit } from '@angular/core';

type CookieConsentChoice = 'accepted' | 'rejected';

@Component({
  selector: 'app-cookie-consent',
  templateUrl: './cookie-consent.component.html',
  styleUrls: ['./cookie-consent.component.scss']
})
export class CookieConsentComponent implements OnInit {
  private readonly STORAGE_KEY = 'cookie_consent_v1';

  visible = false;
  consent: CookieConsentChoice | null = null;

  ngOnInit(): void {
    this.consent = this.getStoredConsent();
    this.visible = this.consent === null;
  }

  acceptAll(): void {
    this.setConsent('accepted');
    // If you later integrate analytics/pixels, trigger enable logic here.
  }

  reject(): void {
    this.setConsent('rejected');
    // If you later integrate analytics/pixels, ensure they stay disabled here.
  }

  // -------- Helpers --------
  private setConsent(choice: CookieConsentChoice): void {
    this.consent = choice;
    localStorage.setItem(
      this.STORAGE_KEY,
      JSON.stringify({
        choice,
        timestamp: new Date().toISOString(),
      })
    );
    this.visible = false;
  }

  private getStoredConsent(): CookieConsentChoice | null {
    try {
      const raw = localStorage.getItem(this.STORAGE_KEY);
      if (!raw) return null;

      const parsed = JSON.parse(raw);
      const choice = parsed?.choice as CookieConsentChoice | undefined;

      if (choice === 'accepted' || choice === 'rejected') return choice;
      return null;
    } catch {
      return null;
    }
  }
}

